import {createAction} from 'redux-act';

export const CHANGE_AMOUNT_ITEMS_REFUND_ORDER = createAction(
  'refundV2/CHANGE_AMOUNT_ITEMS_REFUND_ORDER'
);
export const CHANGE_STATUS_CONFIRMATION_MODAL = createAction(
  'refundV2/CHANGE_STATUS_CONFIRMATION_MODAL'
);
export const CHANGE_STATUS_CREATE_MODAL = createAction(
  'refundV2/CHANGE_STATUS_CREATE_MODAL'
);
export const SET_DATA_FOR_REFUND = createAction('refundV2/SET_DATA_FOR_REFUND');
export const CLEAR_REFUND_DATA = createAction('refundV2/CLEAR_REFUND_DATA');
export const UPDATE_REFUND_DATA = createAction('refundV2/UPDATE_REFUND_DATA');
export const SET_REFUND_LOADING = createAction('refundV2/SET_REFUND_LOADING');

export const GET_DATA_FOR_REFUND = createAction('refundV2/GET_DATA_FOR_REFUND');
export const GET_DATA_FOR_REFUND_SUCCESS = createAction(
  'refundV2/GET_DATA_FOR_REFUND_SUCCESS'
);

export const CHANGE_QUANTITY_FOR_REFUND = createAction(
  'refundV2/CHANGE_QUANTITY_FOR_REFUND'
);
export const CHECK_MODIFIER_FOR_REFUND = createAction(
  'refundV2/CHECK_MODIFIER_FOR_REFUND'
);
export const SELECT_ADJUST_FOR_REFUND = createAction(
  'refundV2/SELECT_ADJUST_FOR_REFUND'
);
export const SELECT_TIPS_FOR_REFUND = createAction(
  'refundV2/SELECT_TIPS_FOR_REFUND'
);
